var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoData = function SvgNoData(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "url(#paint0_linear_5936_31404)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 45H78C80.2091 45 82 46.7909 82 49V85C82 89.4183 78.4183 93 74 93H34C29.5817 93 26 89.4183 26 85V45Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C26 38.7909 27.7909 37 30 37H44.3431C45.404 37 46.4214 37.4214 47.1716 38.1716L54 45H26V41Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45H78C80.2091 45 82 46.7909 82 49V81C82 85.4183 78.4183 89 74 89H34C31.7909 89 30 87.2091 30 85V45Z",
    fill: "#824600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41C30 38.7909 31.7909 37 34 37H44.3431C45.404 37 46.4214 37.4214 47.1716 38.1716L54 45H30V41Z",
    fill: "#824600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 74C30 71.7909 31.7909 70 34 70V70C36.2091 70 38 71.7909 38 74V85C38 87.2091 36.2091 89 34 89V89C31.7909 89 30 87.2091 30 85V74Z",
    fill: "#824600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1917 51.9394C47.6691 50.2032 49.2478 49 51.0485 49H98.7515C101.393 49 103.309 51.5142 102.608 54.0606L94.6167 83.1213C93.6617 86.5937 90.5043 89 86.903 89H37L47.1917 51.9394Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 89H34C35.772 89 37.3256 87.816 37.7955 86.1074L43.05 67L41.5 89Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1961 51.9475C51.6707 50.2073 53.2514 49 55.0552 49H98.763C101.4 49 103.316 51.5079 102.622 54.0525L93.6077 87.1049C92.6585 90.5854 89.4972 93 85.8896 93H40L51.1961 51.9475Z",
    fill: "#BD8800"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 93H34C37.544 93 40.6512 90.6319 41.5909 87.2148L46.05 71L44.5 93Z",
    fill: "#BD8800"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5936_31404",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#6B0707"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5936_31404)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 23.5,
    width: 3,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.817,
    y: 26.317,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(30 93.817 26.317)",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.575,
    y: 36.317,
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "rotate(60 103.575 36.317)",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5936_31404",
    x1: 60,
    y1: 0,
    x2: 60,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC75"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "no-data.57fe83adae69be40c48a70fa8cc4bd25.svg";